import React from 'react'
import LogsListing from '../../../../../../../../../itrust_common/components/others/listings/LogsListing'
import { Field, FieldArray } from 'redux-form'
import SpecteraFormButton from '../SpecteraFormButton'
import { Checkbox } from '../../../../../../../../../itrust_common/components/form'

export default function SpecteraStep1(props) {
  const { visionInsuranceClaimForm, actionLabel } = props

  const LogsHead = [
    { title: '' },
    { title: 'Service', className: 'text-nowrap' },
    { title: 'Availability', className: 'text-nowrap' },
  ]

  const RenderSpecteraClaimService = (props) => {
    const { fields } = props

    const serviceData = fields.getAll() || []

    const contactsBenefitSelected = serviceData.some(
      (item) =>
        item?.service_type === 'Contacts Benefit' && item?.active
    )

    const frameOrLensSelected = serviceData.some(
      (item) =>
        ['Frame Benefit', 'Lens Benefit'].includes(item?.service_type) &&
        item?.active
    )

    return (
      <>
        {fields.map((member, index, members) => {
          const service = members.get(index) || {}
          const serviceType = service.service_type

          const unavailable =
            service.button_clickable === false ||
            service.button_clickable === 'No' ||
            service.availability?.toLowerCase() === 'no'

          const mutuallyExclusive =
            (serviceType === 'Contacts Benefit' &&
              frameOrLensSelected) ||
            (['Frame Benefit', 'Lens Benefit'].includes(serviceType) &&
              contactsBenefitSelected)

          return (
            <tr key={member}>
              <td>
                <Field
                  name={`${member}[active]`}
                  component={Checkbox}
                  disabled={mutuallyExclusive}
                  wrapperClasses="pl-4"
                />
              </td>
              <td>{serviceType}</td>
              <td>{service.availability}</td>
            </tr>
          )
        })}
      </>
    )
  }

  return (
    <LogsListing
      logs={visionInsuranceClaimForm?.eligibility?.data}
      TableHead={LogsHead}
    >
      <FieldArray
        name="eligibility.data"
        props={{ visionInsuranceClaimForm }}
        component={RenderSpecteraClaimService}
      />
      <tr>
        <td colSpan={10}>
          <SpecteraFormButton
            buttonClasses="py-2"
            actionLabel={actionLabel}
          />
        </td>
      </tr>
    </LogsListing>
  )
}